module.exports = __webpack_public_path__ + "images/58d405a1.jpg";